export default "__VITE_ASSET__DU_lONI6__"